// Français — traductions professionnelles, formelles (vous).
const fr = {
  translation: {
    nav: {
      profile: "Profil",
      dashboard: "Tableau de bord",
      analytics: "Analytique",
      wallet: "Mon portefeuille",
      send_topup: "Envoyer une recharge",
      gift_cards: "Cartes cadeaux",
      pay_bills: "Services & Factures",
      agents: "Mes Agents",
      subagent_tx: "Transactions des sous-agents",
      master_agents: "Master Agents",
      set_commissions: "Configurer les commissions",
      my_commissions: "Mes commissions",
      master_commissions: "Commissions Master",
      master_payouts: "Paiements",
      transfer_funds: "Transférer des fonds",
      reports: "Rapports",
      settings: "Devise locale",
      make_payment: "Effectuer un paiement",
      send_cash: "Envoyer de l'argent",
      cash_verification: "Vérification d'espèces",
      exchange_rates: "Taux et frais",
      branding_settings: "Branding Settings",
      pending_codes: "Codes en attente",
      sms_diagnostics: "Diagnostic SMS",
      provider_management: "Gestion des fournisseurs",
      pending_password_reset_codes: "Codes de réinitialisation en attente",
      trusted_devices: "Appareils de confiance",
      audit_log: "Journal d'audit",
      my_activity: "Mon activité",
      section_navigation: "Navigation",
      folder_my_agents: "Mes Agents",
      folder_master_agents: "Master Agents",
      logout: "Déconnexion",
      folder_create_agent: "Créer un agent",
      folder_agent_management: "Gestion des agents",
      folder_create_subagent: "Créer un sous-agent",
      folder_management: "Gestion",
      folder_subagent_tx: "Transactions des sous-agents",
      folder_subagent_sales: "Ventes des sous-agents",
      folder_gross_sales: "Rapport de ventes brutes",
      folder_set_agent_commissions: "Configurer les commissions",
      folder_network_performance: "Performance du réseau",
      folder_create_master: "Créer un Master Agent",
      folder_master_list: "Liste des Master Agents",
      folder_master_commissions: "Commissions Master",
      folder_set_master_commissions: "Configurer les commissions Master",
      folder_master_sales: "Ventes des Master Agents",
      folder_master_tx: "Transactions des Master Agents",
      folder_commission_reports: "Rapports de commissions",
      folder_my_wallet: "Mon portefeuille",
      folder_currencies: "Devises",
      folder_send_external_transfer: "Envoyer un transfert externe",
      folder_funding_history: "Historique de financement",
      signed_in_as: "Connecté en tant que",
      sign_out: "Se déconnecter",
    },
    role: {
      MASTER_ADMIN: "Master Admin",
      MASTER_AGENT: "Master Agent",
      AGENT: "Agent",
      CASH_VERIFIER: "Vérificateur d'espèces",
    },
    auth: {
      brand_tagline: "Plateforme mondiale de revente de recharges mobiles",
      sign_in_title: "Connectez-vous à votre compte",
      sign_in_sub: "Entrez vos identifiants pour continuer.",
      welcome_back: "Bon retour !",
      username_placeholder: "Saisissez votre identifiant",
      password_placeholder: "Saisissez votre mot de passe",
      username: "Nom d'utilisateur",
      username_or_email: "Nom d'utilisateur ou e-mail",
      password: "Mot de passe",
      remember_me: "Se souvenir de moi",
      sign_in: "Se connecter",
      signing_in: "Connexion…",
      forgot_password: "Mot de passe oublié ?",
      new_here: "Nouveau ici ?",
      create_account: "Créer un compte",
      have_account: "Vous avez déjà un compte ?",
      register_title: "Créez votre compte",
      register_sub: "Enregistrez un nouveau compte de revendeur.",
      name: "Prénom",
      last_name: "Nom",
      email: "E-mail",
      phone: "Téléphone",
      confirm_password: "Confirmer le mot de passe",
      passwords_dont_match: "Les mots de passe ne correspondent pas.",
      register: "S'inscrire",
      registering: "Inscription…",
      forgot_title: "Mot de passe oublié ?",
      forgot_sub: "Entrez votre e-mail — nous vous enverrons un lien de réinitialisation.",
      send_reset_link: "Envoyer le lien",
      sending: "Envoi…",
      back_to_login: "Retour à la connexion",
      back_to_landing: "Retour à la page d'accueil",
      reset_title: "Réinitialiser votre mot de passe",
      reset_sub: "Choisissez un nouveau mot de passe pour votre compte.",
      new_password: "Nouveau mot de passe",
      reset_password: "Réinitialiser le mot de passe",
      resetting: "Réinitialisation…",
      reset_success: "Mot de passe réinitialisé. Vous pouvez maintenant vous connecter.",
      email_sent: "Consultez votre boîte de réception pour les instructions.",
      two_factor_title: "Entrez le code de vérification",
      two_factor_sub: "Nous avons envoyé un code à 6 chiffres à {{email}}. Il expire dans {{minutes}} minutes.",
      code: "Code de vérification",
      verify: "Vérifier",
      verifying: "Vérification…",
      resend_code: "Renvoyer le code",
      resend_in: "Renvoyer dans {{seconds}} s",
      trust_device: "Faire confiance à cet appareil (SMS ignoré la prochaine fois)",
      device_name: "Nom de l'appareil (optionnel)",
      cancel: "Annuler",
      pw_rule_length: "Au moins 8 caractères",
      pw_rule_upper: "Une lettre majuscule (A-Z)",
      pw_rule_lower: "Une lettre minuscule (a-z)",
      pw_rule_digit: "Un chiffre (0-9)",
      pw_rule_special: "Un caractère spécial (!@#$…)",
    },
    pwreset: {
      title: "Mot de passe oublié ?",
      step1_sub: "Saisissez votre identifiant, votre e-mail ou votre numéro de téléphone enregistré. Nous vous enverrons un code à 6 chiffres par SMS.",
      step1_sub_v2: "Saisissez votre adresse e-mail enregistrée ou votre numéro de téléphone mobile enregistré. Nous enverrons un code à 6 chiffres par SMS au téléphone associé à votre compte.",
      identifier_label: "Identifiant, e-mail ou téléphone (E.164)",
      identifier_label_v2: "E-mail ou numéro de téléphone mobile",
      identifier_placeholder_v2: "Saisissez votre e-mail enregistré ou votre numéro de téléphone mobile enregistré",
      identifier_examples: "Exemples : john@example.com  ·  +56961234567",
      identifier_invalid: "Saisissez un e-mail valide (nom@exemple.com) ou un téléphone au format E.164 (par ex. +56961234567).",
      send_sms: "Envoyer le code de vérification",
      step2_title: "Saisissez le code SMS",
      step2_sub_sent: "Un code à 6 chiffres a été envoyé au",
      step2_sub_expiry: "Il expire dans 5 minutes.",
      step2_sub_generic: "Si ce compte existe, un code à 6 chiffres a été envoyé au numéro enregistré. Il expire dans 5 minutes.",
      step2_generic_v2: "Si les informations saisies sont valides, un code de vérification a été envoyé. Il expire dans 5 minutes.",
      step2_nomatch_hint: "Vous ne recevez rien ? Vérifiez votre identifiant, e-mail ou numéro de téléphone (format E.164 comme +56961000199). Si votre compte est enregistré sans numéro, contactez le support.",
      code_label: "Code à 6 chiffres",
      resend_in: "Renvoyer dans {{s}} s",
      resend_sms: "Renvoyer le SMS",
      change_identifier: "Utiliser un autre compte",
      change_identifier_v2: "Utiliser un autre e-mail ou téléphone",
      verify: "Vérifier le code",
      invalid_code_generic: "Le code saisi n'est pas valide ou a expiré.",
      step3_title: "Créer un nouveau mot de passe",
      step3_sub: "Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial.",
      step3_sub_v2: "Choisissez un mot de passe robuste. Toutes les exigences ci-dessous doivent être remplies.",
      new_password: "Nouveau mot de passe",
      confirm_password: "Confirmer le nouveau mot de passe",
      pw_rule_length: "Au moins 8 caractères",
      pw_rule_letter: "Au moins une lettre",
      pw_rule_digit: "Au moins un chiffre",
      pw_rule_no_edge_space: "Aucun espace au début ou à la fin",
      updating: "Mise à jour…",
      update_password: "Mettre à jour le mot de passe",
      reset_password: "Réinitialiser le mot de passe",
      mismatch: "Les mots de passe ne correspondent pas.",
      resent: "Nouveau SMS envoyé ({{used}}/{{max}})",
      done_title: "Mot de passe mis à jour",
      done_title_v2: "Mot de passe mis à jour avec succès",
      done_sub: "Toutes les sessions actives et les appareils de confiance de ce compte ont été révoqués. Connectez-vous avec votre nouveau mot de passe — un nouveau code SMS sera requis pour cet appareil.",
      done_sub_v2: "Votre mot de passe a été mis à jour avec succès.",
      back_to_login: "Retour à la connexion",
      step_identify: "Identifier",
      step_verify: "Vérifier",
      step_new: "Nouveau mot de passe",
    },
    dashboard: {
      title: "Tableau de bord",
      welcome: "Bon retour",
      today: "Aujourd'hui",
      week: "Cette semaine",
      month: "Ce mois",
      custom: "Plage personnalisée",
      range_yesterday: "Hier",
      range_7d: "7 derniers jours",
      range_30d: "30 derniers jours",
      range_last_month: "Mois dernier",
      range_from: "Du",
      range_to: "Au",
      kpi_available_balance: "Solde disponible",
      kpi_total_sales: "Ventes totales",
      kpi_my_commissions: "Mes commissions",
      kpi_total_transactions: "Transactions totales",
      kpi_master_agents: "Master Agents",
      kpi_total_agents: "Total des agents",
      kpi_network_volume: "Volume du réseau",
      kpi_top_performer: "Meilleure performance",
      internal_pool: "Réserve interne",
      lifetime: "Historique",
      sales_by_master: "Ventes par Master Agent",
      sales_by_agent: "Ventes par sous-agent",
      col_id: "ID",
      col_created: "Créé",
      col_product: "Produit",
      col_phone: "Téléphone",
      col_amount_paid: "Montant payé",
      col_customer_receives: "Le client reçoit",
      master_wallet_balance: "Solde du Master Wallet",
      master_wallet_hint: "Portefeuille de la plateforme finançant tout le réseau",
      last_updated: "dernière mise à jour",
      add_funds: "Ajouter des fonds",
      low_balance_warning: "Solde faible — sous le seuil de {{threshold}}. Pensez à ajouter des fonds.",
      transactions: "Transactions",
      funding_history: "Historique des fonds",
      recent_transactions: "Transactions récentes",
      quick_actions: "Actions rapides",
      view_all: "Voir tout",
      no_transactions: "Aucune transaction pour l'instant.",
      pending_topups: "En attente",
      successful_topups: "Recharges réussies",
      failed_topups: "Recharges échouées",
      sales_today: "Ventes du jour",
    },
    wallet: {
      title: "Mon portefeuille",
      subtitle: "Suivez votre solde, votre grand livre et l'historique de vos fonds.",
      current_balance: "Solde actuel",
      available: "Disponible",
      currency_usd: "USD",
      request_funds: "Demander des fonds",
      add_funds: "Ajouter des fonds",
      export: "Exporter",
      transactions_tab: "Mouvements",
      funding_tab: "Historique des fonds",
      col_date: "Date",
      col_type: "Type",
      col_source: "Catégorie",
      col_reference: "Référence",
      col_amount: "Montant",
      col_balance_after: "Solde après",
      col_notes: "Note",
      col_status: "Statut",
      no_entries: "Aucune écriture pour l'instant.",
      no_funding: "Aucune demande de fonds pour l'instant.",
      loading: "Chargement du portefeuille…",
      status_pending: "En attente",
      status_approved: "Approuvé",
      status_rejected: "Rejeté",
      type_credit: "CRÉDIT",
      type_debit: "DÉBIT",
      cat_topup_hold: "Recharge (retenue)",
      cat_topup_reversal: "Annulation de recharge",
      cat_topup_trueup: "Ajustement de recharge",
      cat_commission: "Commission",
      cat_master_commission_payout: "Commission hebdomadaire Master Agent",
      cat_master_commission_reversal: "Annulation commission Master Agent",
      cat_transfer_in: "Transfert reçu",
      cat_transfer_out: "Transfert envoyé",
      cat_funding: "Ajout de fonds",
      cat_funding_payku: "Fonds via Payku",
      cat_funding_manual: "Fonds manuels",
      cat_funding_card: "Fonds par carte",
    },
    topup: {
      title: "Envoyer une recharge",
      subtitle: "Envoyez du crédit mobile à tout opérateur pris en charge dans le monde.",
      country: "Pays",
      operator: "Opérateur",
      product: "Produit",
      phone: "Numéro de téléphone",
      select_country: "Sélectionnez un pays",
      select_operator: "Sélectionnez un opérateur",
      select_product: "Sélectionnez un produit",
      phone_placeholder: "Entrez le numéro du destinataire",
      estimate: "Estimer",
      estimating: "Estimation…",
      send: "Envoyer la recharge",
      sending: "Envoi…",
      cost_usd: "Coût (USD)",
      amount_to_send: "Montant à envoyer",
      recipient_receives: "Le destinataire reçoit",
      commission: "Votre commission",
      confirm_title: "Confirmer la recharge",
      confirm_sub: "Vérifiez les détails avant d'envoyer.",
      confirm_send: "Confirmer et envoyer",
      success_title: "Recharge envoyée !",
      success_sub: "Transaction n° {{id}} complétée avec succès.",
      failed_title: "Recharge échouée",
      failed_sub: "La transaction n'a pas pu être complétée. Votre solde a été remboursé.",
      no_products: "Aucun produit disponible pour l'opérateur sélectionné.",
      insufficient_balance: "Solde insuffisant dans le portefeuille.",
      recent: "Recharges récentes",
      view_receipt: "Voir le reçu",
      print: "Imprimer",
      status_success: "Réussi",
      status_pending: "En attente",
      status_failed: "Échoué",
      status_cancelled: "Annulé",
      status_hold: "En attente",
    },
    cash: {
      title: "Envoyer de l'argent",
      subtitle: "Envoyez des transferts d'argent — retrait aux points d'agents.",
      failed_credit: "Échec du crédit du portefeuille",
      failed_send: "Échec de l'envoi",
      provide_reject_reason: "Veuillez indiquer un motif de rejet",
      provide_verifier_account: "Entrez le compte vérificateur qui a confirmé cette transaction",
      recipient_name: "Prénom du destinataire",
      recipient_last_name: "Nom du destinataire",
      recipient_phone: "Téléphone du destinataire",
      recipient_country: "Pays du destinataire",
      recipient_city: "Ville du destinataire",
      amount_usd: "Montant (USD)",
      note: "Note (optionnelle)",
      review: "Vérifier",
      send_cash: "Envoyer l'argent",
      sending: "Envoi…",
      confirm_title: "Confirmer le transfert",
      confirm_sub: "Vérifiez les détails avant d'envoyer.",
      confirm_send: "Confirmer et envoyer",
      success_title: "Transfert créé",
      success_sub: "Code de retrait : {{code}}",
      insufficient_balance: "Solde insuffisant.",
      recent: "Transferts récents",
      col_recipient: "Destinataire",
      col_amount: "Montant",
      col_status: "Statut",
      col_created: "Créé",
      col_pickup_code: "Code de retrait",
      status_pending: "En attente",
      status_completed: "Complété",
      status_cancelled: "Annulé",
    },
    profile: {
      title: "Profil",
      subtitle: "Gérez vos informations personnelles, votre sécurité et vos préférences.",
      tab_personal: "Informations personnelles",
      tab_password: "Mot de passe",
      tab_preferences: "Préférences",
      tab_billing: "Informations de facturation",
      account_number: "Numéro de compte",
      name: "Prénom",
      last_name: "Nom",
      email: "E-mail",
      phone: "Téléphone",
      state: "État / Région",
      city: "Ville",
      address: "Adresse",
      save: "Enregistrer les modifications",
      saving: "Enregistrement…",
      saved: "Profil enregistré",
      current_password: "Mot de passe actuel",
      new_password: "Nouveau mot de passe",
      confirm_password: "Confirmer le nouveau mot de passe",
      change_password: "Changer le mot de passe",
      changing_password: "Changement…",
      password_changed: "Mot de passe changé avec succès.",
      password_changed_signout: "Mot de passe mis à jour. Toutes les sessions et les appareils de confiance ont été révoqués — connectez-vous à nouveau avec votre nouveau mot de passe.",
      passwords_dont_match: "Les mots de passe ne correspondent pas.",
      pw_rule_length: "Au moins 8 caractères",
      pw_rule_letter: "Au moins une lettre",
      pw_rule_digit: "Au moins un chiffre",
      pw_rule_no_edge_space: "Aucun espace au début ou à la fin",
      pw_same_as_current: "Le nouveau mot de passe doit être différent de l'actuel.",
    },
    settings: {
      title: "Devise locale",
      subtitle: "Configurez l'affichage des montants pour vous et vos clients.",
      currency: "Devise",
      exchange_rate: "Taux de change (1 USD =)",
      save: "Enregistrer",
      saved: "Paramètres enregistrés",
      preferences: "Préférences",
      language: "Langue de l'interface",
      language_hint: "Les changements s'appliquent immédiatement à toute l'application.",
    },
    commissions: {
      title: "Configurer les commissions",
      title_master: "Configurer les commissions Master Agent",
      title_agent: "Configurer les commissions Agent",
      subtitle: "Configurez manuellement le pourcentage de commission gagné par chaque agent par opérateur. S'applique à toute recharge ou opération en espèces pour cet opérateur.",
      subtitle_master: "Configurez les pourcentages de commission par opérateur pour les Master Agents. Les agents ne sont pas affichés ici.",
      subtitle_agent: "Configurez les pourcentages de commission par opérateur pour les Agents. Les Master Agents ne sont pas affichés ici.",
      col_master_commission: "Commission Master",
      col_agent_commission: "Commission Agent (%)",
      you_keep: "Vous gardez {{pct}}%",
      pick_agent: "Sélectionnez un agent",
      no_agents: "Vous n'avez pas encore d'agents à configurer.",
      search_products: "Rechercher des produits…",
      country: "Pays",
      operator: "Opérateur",
      all: "Tous",
      col_product: "Produit",
      col_ding_pct: "% Ding",
      col_parent_pct: "Disponible pour vous",
      col_allocated_pct: "Attribué",
      col_remaining_pct: "Restant",
      col_shared_pct: "Déjà partagé",
      save: "Enregistrer",
      saved: "Commission mise à jour",
      invalid_over: "Ne peut pas dépasser le % disponible",
      invalid_under: "Ne peut pas être inférieur au % déjà partagé",
      empty: "Aucun produit ne correspond aux filtres.",
      hierarchy_master: "Le Master Admin attribue depuis Ding ; vous attribuez depuis ce que vous recevez.",
      hierarchy_admin: "Vous attribuez aux Master Agents. Ils distribuent à leurs propres agents.",
      showing: "Affichage de {{count}} produits",
    },
    transfer: {
      title: "Transférer des fonds",
      subtitle: "Déplacez des fonds entre votre master wallet et vos agents.",
      master_balance: "Solde Master",
      available_to_transfer: "Disponible au transfert",
      select_recipient: "Sélectionnez le destinataire",
      recent_title: "Transferts récents",
      audit_hint: "Journal d'audit de tous les mouvements",
      withdraw_out: "Retrait sortant",
      withdraw_in: "Retrait entrant",
    },
    agents: {
      title: "Gestion des agents",
      subtitle: "Créez, modifiez et gérez les agents de votre réseau.",
      create: "Créer un agent",
      edit: "Modifier l'agent",
      col_username: "Nom d'utilisateur",
      col_name: "Nom",
      col_email: "E-mail",
      col_phone: "Téléphone",
      col_balance: "Solde",
      col_status: "Statut",
      col_commission: "Commission %",
      col_created: "Créé",
      col_actions: "Actions",
      active: "Actif",
      inactive: "Inactif",
      activate: "Activer",
      deactivate: "Désactiver",
      no_agents: "Aucun agent pour l'instant. Créez le premier pour commencer.",
      created: "Agent créé",
      updated: "Agent modifié",
      deactivated: "Agent désactivé",
      activated: "Agent activé",
    },
    masters: {
      title: "Master Agents",
      subtitle: "Revendeurs de premier niveau de votre réseau.",
      create: "Créer un Master Agent",
      col_username: "Nom d'utilisateur",
      col_name: "Nom",
      col_email: "E-mail",
      col_phone: "Téléphone",
      col_balance: "Solde",
      col_agents: "Agents",
      col_status: "Statut",
      col_created: "Créé",
      col_actions: "Actions",
      no_masters: "Aucun master agent pour l'instant.",
      created: "Master agent créé",
      updated: "Master agent modifié",
    },
    sub_tx: {
      title: "Transactions des sous-agents",
      subtitle: "Chaque recharge envoyée par les agents de votre réseau.",
      col_agent: "Agent",
      col_product: "Produit",
      col_phone: "Téléphone",
      col_amount: "Montant",
      col_status: "Statut",
      col_created: "Créé",
      no_tx: "Aucune transaction dans la plage sélectionnée.",
    },
    analytics: {
      title: "Analytique",
      subtitle: "Tendances, meilleures performances et santé du réseau.",
      kpi_period_sales: "Ventes de la période",
      kpi_period_topups: "Recharges de la période",
      kpi_avg_ticket: "Panier moyen",
      kpi_success_rate: "Taux de réussite",
      top_agents: "Meilleurs agents",
      top_operators: "Meilleurs opérateurs",
      top_countries: "Meilleurs pays",
      no_data: "Aucune donnée pour la période sélectionnée.",
      crunching: "Calculs en cours…",
      export_failed: "Échec de l'export",
      kpi_total_revenue: "Revenus totaux",
      kpi_send_topups: "Recharges envoyées",
      kpi_send_cash: "Envois d'argent",
      kpi_wallet_funded: "Portefeuille crédité",
      kpi_conv_fees: "Frais commodité",
      agent_profit_margin: "Marge de profit de l'agent",
      kpi_total_agents: "Total agents",
      kpi_master_agents: "Master Agents",
      kpi_active_users: "Utilisateurs actifs",
      inactive: "inactifs",
      kpi_pending_cash: "Espèces en attente",
      kpi_completed: "Terminé",
      kpi_failed: "Échoué",
      financial_stats: "Statistiques financières",
      total_profit: "Profit total",
      total_commission: "Commission totale",
      convenience_fees: "Frais de commodité",
      topup_wallet_balance: "Solde portefeuille recharge",
      money_sent_topup: "Argent envoyé (Recharge)",
      money_sent_cash: "Argent envoyé (Espèces)",
      cash_balances: "Soldes en espèces",
      chart_sales_by_service: "Ventes par service",
      chart_topup_vs_cash: "Recharge vs Espèces",
      chart_daily_revenue: "Revenus quotidiens",
      chart_daily_sub: "Recharge + Espèces (USD équivalents)",
      chart_top_countries: "Meilleurs pays",
      chart_top_countries_sub: "Ventes par destination (Recharge)",
      chart_sales_by_provider: "Ventes par fournisseur",
      chart_sales_by_provider_sub: "Fournisseurs + MonCash/NatCash",
      chart_cash_by_ccy: "Envois d'argent par devise",
      chart_cash_by_ccy_sub: "Montant de base + HTG reçus",
      chart_funding_by_method: "Recharges par mode de paiement",
      chart_funding_sub: "Rechargements portefeuille (RÉUSSIS)",
      chart_top_10_agents: "Top 10 agents",
      chart_top_agents_sub: "Meilleurs vendeurs par revenus (USD)",
      chart_top_10_masters: "Top 10 master agents",
      chart_top_masters_sub: "Ventes réseau (USD)",
      legend_send_topup: "Recharge",
      legend_send_cash: "Espèces",
      legend_total: "Total",
      legend_sales_usd: "Ventes USD",
      legend_sent_base: "Envoyé (base)",
      legend_received_htg: "Reçu (HTG)",
    },
    audit: {
      title: "Journal d'audit",
      title_activity: "Mon activité",
      subtitle: "Chaque action prise sur la plateforme, à jamais.",
      col_when: "Quand",
      col_actor: "Acteur",
      col_action: "Action",
      col_target: "Cible",
      col_ip: "IP",
      col_details: "Détails",
      no_events: "Aucun événement enregistré pour l'instant.",
      admin_scope: "Master Admin",
      activity_scope: "Activité",
      reload: "Recharger",
      search: "Rechercher",
      search_ph: "utilisateur, action, réf, IP…",
      from: "Du",
      to: "Au",
      role: "Rôle",
      action: "Action",
      all_roles: "Tous les rôles",
      all_actions: "Toutes les actions",
      any_status: "Tout statut",
      status_success: "RÉUSSI",
      status_failed: "ÉCHEC",
      clear: "Effacer",
      apply: "Appliquer",
      col_user: "Utilisateur",
      col_role: "Rôle",
      col_status: "Statut",
      loading_trail: "Chargement du journal…",
      no_records: "Aucun enregistrement ne correspond à vos filtres.",
      records_total: "{{n}} enregistrements · page {{page}} sur {{total}}",
      prev: "Préc.",
      next: "Suiv.",
      audit_entry: "Entrée d'audit",
      when: "Quand",
      user: "Utilisateur",
      role_label: "Rôle",
      target: "Cible",
      status: "Statut",
      reference: "Référence",
      ip: "IP",
      device_browser: "Appareil / Navigateur",
      previous: "Précédent",
      new: "Nouveau",
      payload: "Charge utile",
      failed_load: "Échec du chargement du journal",
    },
    trusted: {
      title: "Appareils de confiance",
      subtitle: "Appareils qui ne nécessitent pas de code 2FA pendant les 30 prochains jours.",
      col_device: "Appareil",
      col_last_used: "Dernière utilisation",
      col_ip: "Dernière IP",
      col_expires: "Expire",
      col_actions: "Actions",
      revoke: "Révoquer",
      revoked: "Appareil révoqué",
      no_devices: "Aucun appareil de confiance pour l'instant.",
      reload: "Recharger",
      sign_out_everywhere: "Se déconnecter partout",
      mobile_devices: "Appareils mobiles",
      computers: "Ordinateurs",
      trust_period: "Période de confiance",
      days: "jours",
      no_trusted_hint: "Vous n'avez aucun appareil de confiance. Chaque nouvelle connexion nécessitera un code de vérification par e-mail.",
      confirm_remove: "Supprimer cet appareil ? Vous devrez vérifier par e-mail lors de votre prochaine connexion depuis celui-ci.",
      confirm_force_logout: "Révoquer TOUS les appareils de confiance ? Chaque navigateur nécessitera une nouvelle vérification par e-mail à la prochaine connexion.",
      device_removed: "Appareil de confiance supprimé",
      failed_remove: "Échec de la suppression",
      failed_force_logout: "Échec de la déconnexion forcée",
      failed_load: "Échec du chargement des appareils de confiance",
      revoked_n: "{{n}} appareil(s) révoqué(s)",
      added: "Ajouté",
      last_login: "Dernière connexion",
      trust_expires_in: "La confiance expire dans",
      no_ip: "aucune ip",
      remove: "Supprimer",
      expired: "expiré",
    },
    rates: {
      title: "Taux et frais",
      subtitle: "Gérez les taux de conversion USD → devise locale.",
      col_currency: "Devise",
      col_rate: "Taux (1 USD =)",
      col_updated: "Mis à jour",
      col_actions: "Actions",
      add: "Ajouter une devise",
      save: "Enregistrer",
      saved: "Taux enregistré",
      tab_tiers: "Paliers de frais de commodité",
      exchange_rates_htg: "Taux de change → HTG",
      rates_hint: "1 unité de la devise indiquée = N HTG. Utilisé comme référence pour chaque transaction Envoyer de l'argent.",
      reload: "Recharger",
      loading_rates: "Chargement des taux…",
      loading_tiers: "Chargement des paliers…",
      unit_htg: "1 {{ccy}} = ? HTG",
      last_updated_by: "Mis à jour par {{name}}",
      no_rate_set: "Aucun taux défini — Envoyer de l'argent sera bloqué pour cette devise",
      failed_load_rates: "Échec du chargement des taux",
      failed_load_tiers: "Échec du chargement des paliers",
      enter_valid_rate: "Entrez un taux valide > 0",
      rate_updated: "Taux {{ccy}} → HTG mis à jour à {{n}}",
      save_failed: "Échec de l'enregistrement",
      tiers_updated: "Paliers {{ccy}} mis à jour ({{n}})",
      tiers_hint_1: "Chaque ligne définit un plafond de plage. Un agent peut facturer n'importe quel frais de commodité de",
      tiers_hint_zero: "0",
      tiers_hint_2: "jusqu'au",
      tiers_hint_max_fee: "Frais max",
      tiers_hint_3: "de la ligne correspondant au montant. Laissez",
      tiers_hint_max_amount: "Montant max",
      tiers_hint_4: "vide pour \"aucune limite supérieure\".",
      currency_fee_tiers: "Paliers de frais — {{ccy}}",
      tier_singular: "palier",
      tier_plural: "paliers",
      add_tier: "Ajouter un palier",
      save_changes: "Enregistrer les modifications",
      col_min_amount: "Montant min ({{ccy}})",
      col_max_amount: "Montant max ({{ccy}})",
      col_max_fee: "Frais max ({{ccy}})",
      no_tiers_for: "Aucun palier configuré — les agents ne peuvent pas facturer de frais pour {{ccy}}.",
      remove_tier: "Supprimer le palier",
    },
    cash_verify: {
      title: "Vérification d'espèces",
      subtitle: "Approuvez les demandes de retrait en attente.",
      col_agent: "Agent",
      col_amount: "Montant",
      col_reference: "Référence",
      col_submitted: "Soumis",
      col_actions: "Actions",
      approve: "Approuver",
      reject: "Rejeter",
      approved: "Approuvé",
      rejected: "Rejeté",
      no_pending: "Aucune demande en attente.",
      status_pending: "En attente",
      status_confirmed: "Confirmé",
      status_rejected: "Rejeté",
      status_all: "Tous",
      provider: "Fournisseur",
      status: "Statut",
      back_profile: "← Profil",
      back_send_cash: "← Retour à Envoyer de l'argent",
      failed_load: "Échec du chargement",
      wallet_balance: "Solde du portefeuille",
      commission_earned: "Commission gagnée",
      commission_rate_hint: "taux {{pct}}%",
      pending: "En attente",
      confirmed: "Confirmé",
      verification_users: "Utilisateurs de vérification",
      dedicated_hint: "Deux comptes dédiés qui traitent les demandes Envoyer de l'argent pour chaque fournisseur.",
      not_configured: "(non configuré)",
      verifier_label: "vérificateur {{provider}}",
      edit: "Modifier",
      create: "Créer",
      balance: "Solde",
      commission: "Commission",
      earned: "Gagné",
      show_only_verifier: "Afficher uniquement le travail de ce vérificateur →",
      showing_only_verifier: "✓ Affichage du travail de ce vérificateur uniquement",
    },
    pending_codes: {
      title: "Codes en attente",
      subtitle: "Codes 2FA actifs en attente d'utilisation.",
      col_user: "Utilisateur",
      col_role: "Rôle",
      col_code: "Code",
      col_expires: "Expire",
      no_codes: "Aucun code en attente.",
      breadcrumb: "Sécurité · Support",
      long_subtitle: "Codes de vérification par e-mail actifs en attente — pour les Agents et les Master Agents. Visible uniquement pour Master Admin et Master Agents. Chaque lecture est enregistrée dans le Journal d'audit.",
      reload: "Recharger",
      filter_all: "Tous",
      filter_masters: "Master Agents",
      filter_agents: "Agents",
      filter_verifiers: "Utilisateurs de vérification",
      filter_moncash: "Vérificateur MonCash",
      filter_natcash: "Vérificateur NatCash",
      col_username: "Nom d'utilisateur",
      col_email: "E-mail",
      col_created: "Créé",
      col_status: "Statut",
      loading: "Chargement…",
      no_active: "Aucun code actif. Lorsqu'un utilisateur en demandera un, il apparaîtra ici pendant 5 minutes.",
      min_left: "{{n}} min restantes",
      copy_code: "Copier le code",
      code_copied: "Code copié dans le presse-papiers",
      failed_load: "Échec du chargement des codes en attente",
      escalation_path: "Voie d'escalade :",
      escalation_text: "Si un agent ne peut pas recevoir son code, il contacte son Master Agent. Si le Master Agent ne peut pas résoudre, il contacte le Master Admin.",
    },
    // Chaînes d'interface partagées — utilisées à travers les pages/composants.
    my_commissions: {
      title: "Mes commissions",
      subtitle: "Le pourcentage de commission qui vous est attribué par opérateur. Ces informations sont en lecture seule — contactez votre Master Agent pour demander des modifications.",
      operators: "Opérateurs",
      with_commission: "Avec commission",
      no_commission: "Sans commission",
      search_operators: "Rechercher des opérateurs…",
      country: "Pays",
      country_all: "Tous",
      only_assigned: "Afficher uniquement les opérateurs avec commission",
      col_id: "ID",
      col_product: "Produit",
      col_country_operator: "Pays / Opérateur",
      col_commission: "Commission",
      col_status: "Statut",
      cash_badge: "espèces",
      no_assigned_yet: "Aucune commission ne vous a encore été attribuée. Contactez votre Master Agent.",
      no_match: "Aucun opérateur ne correspond à vos filtres.",
    },
    reports: {
      tab_charts: "Graphiques",
      tab_sales: "Ventes par statut",
      tab_master_agents: "Par master agent",
      tab_agents: "Par agent",
      tab_operators: "Par opérateur",
      tab_countries: "Par pays",
      tab_commissions: "Commissions",
      tab_search: "Rechercher transactions",
      range_all: "Toute la période",
      range_today: "Aujourd'hui",
      range_yesterday: "Hier",
      range_7d: "7 derniers jours",
      range_30d: "30 derniers jours",
      range_month: "Ce mois",
      range_last_month: "Mois dernier",
      range_custom: "Plage personnalisée",
      loading: "Chargement…",
      no_data: "Aucune donnée pour ce rapport.",
      col_status: "Statut",
      col_count: "Nombre",
      col_total: "Total",
      col_commission: "Commission",
      col_id: "ID",
      col_master_agent: "Master agent",
      col_agents_count: "Agents",
      col_topups: "Recharges",
      col_network_sales: "Ventes réseau",
      col_commissions_paid: "Commissions payées",
      col_agent: "Agent",
      col_total_sales: "Ventes totales",
      col_operator: "Opérateur",
      col_country: "Pays",
      no_data_short: "Aucune donnée.",
      search_by_phone: "Rechercher par numéro de téléphone (complet ou partiel, ex. 5093 ou 50937188551)",
      kpi_available_balance: "Solde disponible",
      kpi_total_sales: "Ventes totales",
      kpi_my_commissions: "Mes commissions",
      kpi_total_transactions: "Total des transactions",
      showing_data: "Affichage des données pour",
      chart_sales_earnings_month: "Ventes et gains par mois",
      last_6_months: "6 derniers mois",
      chart_sales_by_products: "Ventes par produit",
      top_operators_range: "Top 6 opérateurs · plage sélectionnée",
      chart_sales_by_week: "Ventes par semaine",
      chart_sales_by_master: "Ventes par Master Agent",
      top_8_range: "Top 8 · plage sélectionnée",
      chart_payments_debits: "Paiements vs Débits",
      wallet_movements: "Mouvements du portefeuille dans la plage",
      last_8_weeks: "8 dernières semaines",
      payments_in: "Paiements",
      debits_out: "Débits",
      no_data_range: "Aucune donnée pour la plage sélectionnée.",
      lifetime_earnings: "Vos gains totaux de commission",
      total_earned: "Total gagné",
      no_commission_earnings: "Aucune commission gagnée pour l'instant.",
      no_transactions_for: "Aucune transaction trouvée pour \"{{phone}}\".",
      customer_paid: "Payé par le client",
      usd_internal: "USD (interne)",
      rate: "Taux",
      legend_sales: "Ventes",
      legend_earnings: "Gains",
      export_master_csv: "CSV Master Agent",
      export_agent_csv: "CSV Agent",
      export_operator_csv: "CSV Opérateur",
      export_country_csv: "CSV Pays",
    },
    send_cash: {
      switch_to_topup: "Basculer vers Envoyer une recharge",
      wallets_all: "Portefeuilles Envoyer de l'argent · toutes devises",
      wallet_balance_label: "Solde Envoyer de l'argent",
      wallet_hint: "Ce solde est utilisé uniquement pour Envoyer de l'argent (MonCash / NatCash). Il est distinct de votre portefeuille Envoyer une recharge.",
      transfer_cash_agent: "Transférer de l'argent à un agent",
      open_cash_verification: "Ouvrir la vérification d'espèces",
      full_name_required: "Nom complet *",
      full_name_hint: "Entrez le nom complet du destinataire exactement tel qu'il apparaît sur son compte MonCash / NatCash.",
      recipient_phone_required: "Téléphone du destinataire *",
      haiti_prefix: "Haïti · +509",
      haiti_country_code: "Code pays Haïti",
      phone_hint: "Le code pays +509 est appliqué pour Haïti. Entrez le numéro local à 8 chiffres.",
      detected: "Détecté",
      admin_override: "Remplacement admin :",
      could_not_detect: "Impossible de détecter automatiquement le portefeuille Haïti. Vérifiez le numéro.",
      amount_to_send_ccy: "Montant à envoyer ({{ccy}}) *",
      amount_to_send_usd: "Montant à envoyer (USD) *",
      convenience_fee_ccy: "Frais de commodité ({{ccy}})",
      convenience_fee_usd: "Frais de commodité (USD)",
      max_fee: "Max {{n}} USD",
      max_fee_ccy: "Max {{n}} {{ccy}}",
      exceeds_balance: "Dépasse votre solde ({{balance}})",
      live_summary: "Résumé en direct",
      amount_to_send: "Montant à envoyer",
      convenience_fee: "Frais de commodité",
      total_to_pay: "Total à payer",
      receiver_gets: "Le destinataire reçoit",
      exchange_rate: "Taux de change",
      note_optional_upper: "Note / référence (optionnel)",
      internal_reference: "Référence interne affichée sur le reçu",
      only_amount_debited: "Seul ce montant est débité de votre portefeuille.",
      profit_kept: "Votre profit. Vous le gardez — jamais déduit du portefeuille.",
    },
    providers: {
      breadcrumb: "Admin · Gestion des fournisseurs",
      title: "Réseau {{brand}}",
      subtitle: "Détails internes des fournisseurs. Visible uniquement pour le Master Admin — les master agents, agents et clients ne voient jamais cette section.",
      master_only: "Master Admin uniquement",
    },
    ui: {
      show: "Afficher",
      entries: "entrées",
      of: "sur",
      page: "Page",
      per_page: "{{n}} / page",
      apply: "Appliquer",
      prev: "Préc.",
      previous: "Précédent",
      next: "Suivant",
      showing: "Affichage",
      showing_range: "Affichage {{from}} – {{to}} sur {{total}} {{noun}}",
      network: "Réseau",
      loading: "Chargement…",
      actions_btn: "Actions",
      view_sales: "Voir les ventes",
      view_agents: "Voir les agents",
      edit_agent: "Modifier l'agent",
      edit_master_agent: "Modifier le master agent",
      change_password: "Changer le mot de passe",
      transfer_funds_action: "Transférer des fonds",
      withdraw_funds_action: "Retirer des fonds",
      transfer_cash_action: "Transférer de l'argent",
      withdraw_cash_action: "Retirer de l'argent",
      set_commissions_action: "Configurer les commissions",
      create_agent_title: "Créer un nouvel agent",
      edit_agent_title: "Modifier l'agent",
      create_master_title: "Créer un nouveau master agent",
      edit_master_title: "Modifier le master agent",
      reset_password_title: "Réinitialiser le mot de passe — {{username}}",
      transfer_title: "Transférer des fonds → {{username}}",
      withdraw_title: "Retirer des fonds — {{username}}",
      transfer_cash_title: "Transférer de l'argent → {{username}}",
      withdraw_cash_title: "Retirer de l'argent — {{username}}",
      sales_modal_title: "Ventes — {{name}} ({{code}})",
      network_sales_modal_title: "Ventes réseau — {{name}} ({{code}})",
      full_name: "Nom complet",
      username: "Nom d'utilisateur",
      email: "E-mail",
      phone_number: "Numéro de téléphone",
      password: "Mot de passe",
      commission_pct: "Commission %",
      note_optional: "Note (optionnelle)",
      internal_reference: "Référence interne",
      active_label: "Actif",
      assign_master: "Attribuer à un master agent",
      keep_under_me: "Garder sous ma responsabilité ({{admin}})",
      new_password_min: "Nouveau mot de passe (min. 4 caractères)",
      pw_reset_hint: "L'agent devra utiliser le nouveau mot de passe lors de sa prochaine connexion.",
      amount_transfer_usd: "Montant à transférer (USD)",
      amount_withdraw_max: "Montant à retirer (max {{max}})",
      amount_in: "Montant en {{currency}}",
      amount_transfer_in: "Montant à transférer en {{currency}}",
      amount_withdraw_in: "Montant à retirer en {{currency}}",
      currency: "Devise",
      current_balance: "Solde actuel",
      available: "Disponible",
      current: "Actuel",
      new_agents_hint: "Les nouveaux agents sont créés avec un solde de 0 $. Vous pouvez les créditer depuis Transférer des fonds.",
      new_masters_hint: "Les nouveaux master agents commencent avec un solde de 0 $ et sans sous-agents. Vous pouvez les créditer via Transférer des fonds.",
      cash_wallet_hint: "Portefeuille Envoyer de l'argent (séparé du solde de recharge)",
      pull_cash_hint: "Rapatrier le solde d'Envoyer de l'argent vers votre portefeuille",
      agent_current_balance: "Solde actuel de l'agent",
      master_topup_balance: "Solde de recharge du master agent",
      funds_move_master_to_master: "Les fonds passeront de votre portefeuille master admin vers ce master agent.",
      funds_removed_agent_to_master: "Les fonds seront retirés de l'agent et crédités à votre master wallet.",
      funds_removed_master_to_admin: "Les fonds seront retirés de ce master agent et recrédités à votre Master Admin.",
      search_users: "Rechercher ID, nom, utilisateur, téléphone, e-mail…",
      search_tx: "Rechercher ID, utilisateur, téléphone, ID de transaction…",
      agent_created: "Agent créé",
      agent_updated: "Agent modifié",
      master_created: "Master agent créé",
      master_updated: "Master agent modifié",
      update_failed: "Échec de la mise à jour",
      create_agent_failed: "Échec de la création de l'agent",
      create_master_failed: "Échec de la création du master agent",
      transfer_success: "{{amount}} transférés à {{username}}",
      withdraw_success: "{{amount}} retirés de {{username}}",
      cash_transfer_success: "{{amount}} {{currency}} en espèces transférés à {{username}}",
      cash_withdraw_success: "{{amount}} {{currency}} en espèces retirés de {{username}}",
      transfer_failed: "Échec du transfert",
      withdraw_failed: "Échec du retrait",
      cash_transfer_failed: "Échec du transfert d'argent",
      cash_withdraw_failed: "Échec du retrait d'argent",
      pw_min_4: "Le mot de passe doit contenir au moins 4 caractères",
      pw_reset_for: "Mot de passe réinitialisé pour {{username}}",
      pw_reset_failed: "Échec de la réinitialisation",
      enter_valid_amount: "Entrez un montant valide",
      only_available: "Seulement {{amount}} {{currency}} disponibles",
      only_master_has: "Le master agent n'a que {{amount}} disponibles",
      only_agent_has: "L'agent n'a que {{amount}} disponibles",
      agent_active: "Agent activé",
      agent_inactive: "Agent désactivé",
      master_active: "Master agent activé",
      master_inactive: "Master agent désactivé",
      could_not_load: "Impossible de charger les ventes",
      failed_generic: "Échec",
      subagent_scope_agents: "Transactions des sous-agents dans la plage sélectionnée.",
      subagent_scope_masters: "Transactions des master agents dans la plage sélectionnée.",
      export_csv: "Exporter CSV",
      transactions_lower: "transactions",
      agents_lower: "agents",
      master_agents_lower: "master agents",
      no_subagent_tx: "Aucune transaction de sous-agent dans cette plage.",
      loading_ellipsis: "Chargement…",
      range_today: "Aujourd'hui",
      range_yesterday: "Hier",
      range_7d: "7 derniers jours",
      range_30d: "30 derniers jours",
      range_this_month: "Ce mois",
      range_last_month: "Mois dernier",
      range_custom: "Plage personnalisée",
      agent_col_agent: "Agent",
      col_transactions: "Transactions",
      col_commissions: "Commissions",
      master_agent_label: "Master agent",
      back_to_masters: "Retour aux Master Agents",
      clear_filter: "Effacer le filtre master agent",
      no_data: "Aucune donnée.",
      loading_data: "Chargement des données…",
      created: "Créé",
      updated: "Mis à jour",
      notifications: "Notifications",
      mark_all_read: "Tout marquer comme lu",
      no_notifications: "Aucune notification pour l'instant.",
    },
    common: {
      loading: "Chargement…",
      update: "Mettre à jour",
      save: "Enregistrer",
      cancel: "Annuler",
      close: "Fermer",
      edit: "Modifier",
      delete: "Supprimer",
      confirm: "Confirmer",
      refresh: "Actualiser",
      search: "Rechercher",
      actions: "Actions",
      submit: "Envoyer",
      back: "Retour",
      next: "Suivant",
      previous: "Précédent",
      apply: "Appliquer",
      reset: "Réinitialiser",
      export: "Exporter",
      print: "Imprimer",
      download: "Télécharger",
      copy: "Copier",
      copied: "Copié",
      yes: "Oui",
      no: "Non",
      required: "Obligatoire",
      optional: "Optionnel",
      status: "Statut",
      date: "Date",
      amount: "Montant",
      total: "Total",
      details: "Détails",
      view: "Voir",
      view_details: "Voir les détails",
      loading_more: "Chargement…",
      no_results: "Aucun résultat trouvé.",
      error_generic: "Une erreur est survenue. Veuillez réessayer.",
      success_saved: "Enregistré avec succès.",
      required_field: "Ce champ est obligatoire.",
      invalid_email: "Entrez un e-mail valide.",
      invalid_phone: "Entrez un numéro de téléphone valide.",
      min_password: "Le mot de passe doit contenir au moins 6 caractères.",
    },
    change_role: {
      menu_item: "Changer de rôle / Réaffecter",
      section_label: "Contrôle administrateur",
      title: "Changer le rôle de {{username}}",
      loading: "Chargement des informations actuelles…",
      current_role: "Rôle actuel",
      current_parent: "Parent actuel",
      wallet_balance: "Portefeuille USD",
      history_count: "Recharges · commissions",
      history_hint: "Tout l'historique reste lié",
      new_role: "Nouveau rôle",
      new_parent_admin: "Nouveau parent (Master Admin)",
      new_parent_master: "Nouveau parent — choisissez un Master Admin ou un Master Agent",
      parent_admin: "Master Admin",
      parent_none_admin: "Aucun parent (sommet de la hiérarchie)",
      pick_parent: "Choisissez le nouveau parent…",
      impact_title: "Aperçu de l'impact",
      parent_label: "Parent",
      impact_history: "Solde du portefeuille, journal, recharges, commissions, reçus et audit sont TOUS conservés.",
      impact_wallet: "Les soldes du portefeuille et de Send Cash ne sont pas modifiés.",
      impact_permissions: "Les permissions d'accès seront mises à jour à la prochaine connexion.",
      impact_master_perms_removed: "Les permissions Master Agent seront révoquées. L'utilisateur ne peut plus gérer d'agents.",
      impact_master_perms_granted: "Les permissions Master Agent seront accordées. L'utilisateur pourra créer et gérer ses propres agents.",
      downgrade_title: "{{count}} agents dépendent actuellement de ce master",
      downgrade_hint: "Choisissez où réaffecter ces agents avant de rétrograder cet utilisateur.",
      dg_move_admin: "Déplacer tous ses agents sous Master Admin",
      dg_move_master: "Déplacer tous ses agents vers un autre Master Agent",
      dg_block: "Bloquer le changement tant qu'il a des agents",
      pick_downgrade: "Choisissez comment gérer les sous-agents.",
      pick_downgrade_target: "Choisissez le Master Agent de destination.",
      admin_warn_title: "Promotion en Master Admin",
      admin_warn_hint: "Cela accorde un contrôle total de la plateforme. Faites-le uniquement si vous voulez vraiment partager les droits admin.",
      admin_warn_confirm: "Je comprends que cet utilisateur aura un accès administrateur complet.",
      confirm_admin_first: "Confirmez d'abord la promotion Master Admin.",
      reason: "Motif (facultatif, enregistré dans l'audit)",
      reason_placeholder: "p. ex. Promotion pour expansion régionale",
      confirm_password: "Votre mot de passe administrateur",
      password_placeholder: "Tapez votre mot de passe pour confirmer",
      password_required: "Confirmez avec votre mot de passe administrateur.",
      apply: "Appliquer le changement",
      saved: "Changement de rôle appliqué. Audit mis à jour.",
      failed: "Impossible de changer le rôle.",
      failed_preview: "Impossible de charger les données utilisateur.",
    },
    landing: {
      nav_home: "Accueil",
      nav_about: "À propos",
      nav_services: "Services",
      nav_products: "Produits",
      nav_partners: "Partenaires",
      nav_contact: "Contact",
      cta_login: "Connexion",
      cta_dashboard: "Accéder au tableau de bord",
      hero_kicker: "Instantané · Sécurisé · Mondial",
      hero_title: "Connectez le monde avec {{brand}}",
      hero_subtitle: "Une plateforme simple, rapide et sécurisée pour les recharges mobiles internationales, les paiements numériques et la gestion de votre réseau de revendeurs.",
      hero_cta_learn: "Découvrir les services",
      hero_trust_secure: "Chiffrement de niveau bancaire",
      hero_trust_instant: "Règlement en temps réel",
      hero_trust_multi: "Réseau multi-rôles",
      promo_text: "",
      about_kicker: "À propos",
      about_title: "Conçu pour les revendeurs, adopté par les agents.",
      about_p1_prefix: "{{brand}} est une plateforme mondiale de recharge conçue pour les ",
      about_p1_role1: "master agents",
      about_p1_between: " et les ",
      about_p1_role2: "agents de terrain",
      about_p1_suffix: ". Nous vous fournissons l'ossature opérationnelle — portefeuille, grand-livre, reçus et conformité — pour que vous puissiez vous concentrer sur vos clients.",
      about_p1: "{{brand}} est une plateforme mondiale de recharge conçue pour les master agents et les agents de terrain. Nous vous fournissons l'ossature opérationnelle — portefeuille, grand-livre, reçus et conformité — pour que vous puissiez vous concentrer sur vos clients.",
      about_p2: "Des opérations mono-pays aux réseaux multi-régions, nos outils évoluent avec vous : commissions transparentes, analytique en temps réel et auditabilité de niveau entreprise, prêtes à l'emploi.",
      value_secure_title: "Sécurisé par conception",
      value_secure_desc: "2FA, appareils de confiance, audit sur chaque action.",
      value_realtime_title: "Temps réel",
      value_realtime_desc: "Portefeuille, grand-livre et reçus instantanés.",
      value_hierarchy_title: "Multi-rôles",
      value_hierarchy_desc: "Master Agent · Agent · Collaborateur.",
      value_global_title: "Mondial",
      value_global_desc: "Multi-devises, multi-pays, portefeuilles ancrés USD.",
      value_whitelabel_title: "White Label",
      value_whitelabel_desc: "Marque propre, personnalisation et expérience clé en main pour votre activité.",
      services_kicker: "Services",
      services_title: "Tout ce dont votre réseau de revente a besoin.",
      services_sub: "Quatre services essentiels — une plateforme intégrée, un portefeuille, un tableau de bord.",
      svc_giftcards_title: "Cartes cadeaux",
      svc_giftcards_desc: "Cartes cadeaux numériques pour des marques et plateformes populaires, livrées instantanément.",
      svc_topup_title: "Recharges et paiement de factures",
      svc_topup_desc: "Recharges mobiles instantanées et paiement de factures auprès de centaines d'opérateurs dans le monde entier.",
      svc_intl_calls_title: "Appels internationaux",
      svc_intl_calls_desc: "Nous savons que les temps sont difficiles en ce moment, mais le coût ne devrait pas être un obstacle pour rester en contact avec ses proches.",
      svc_api_title: "Intégration API",
      svc_api_desc: "API REST pour les entreprises et revendeurs qui souhaitent intégrer nativement recharges, retraits d'espèces et cartes cadeaux.",
      products_kicker: "Produits",
      products_title: "Deux façons de gérer votre activité.",
      prod_web_title: "Portail Web",
      prod_web_desc: "Tableau de bord revendeur complet : portefeuille temps réel, recharges instantanées, commissions transparentes, clients vérifiés, reçus et rapports.",
      prod_web_bullet_0: "Hiérarchie multi-rôles — Master Agent · Agent · Collaborateur",
      prod_web_bullet_1: "Portefeuilles USD avec rechargement instantané",
      prod_web_bullet_2: "Reçus PDF et rapports niveau audit",
      prod_web_master_label: "Master Agent",
      prod_web_master_alt: "Aperçu du portail Master Agent",
      prod_web_agent_label: "Agent",
      prod_web_agent_alt: "Aperçu du portail Agent",
      prod_mobile_title: "Application mobile",
      prod_mobile_desc: "Envoyez des recharges, vérifiez les identités, approuvez les retraits et supervisez vos agents où que vous soyez.",
      prod_mobile_bullet_0: "Expérience native pour les agents en déplacement",
      prod_mobile_bullet_1: "Notifications push pour les approbations en attente",
      prod_mobile_bullet_2: "Reçus consultables hors ligne",
      prod_mobile_coming_soon: "Bientôt disponible",
      prod_mobile_alt: "Aperçu de la future application mobile My GlobalTopup",
      partners_kicker: "Services disponibles",
      partners_title: "Envoyez des recharges vers les principaux opérateurs.",
      partners_sub: "Voici un aperçu des opérateurs accessibles via notre plateforme. Contactez notre équipe support pour la liste complète — des centaines de réseaux dans des dizaines de pays.",
      partners_disclaimer: "Toutes les marques, noms commerciaux et logos mentionnés appartiennent à leurs propriétaires respectifs et sont affichés uniquement pour identifier les services disponibles via notre plateforme.",
      stats_title: "Nous parlons avec des chiffres",
      stat_operators: "Opérateurs",
      stat_countries: "Pays disponibles",
      stat_users: "Utilisateurs dans le monde",
      stat_support: "Support client",
      cta_title: "Prêt à commencer à revendre ?",
      cta_sub: "Connectez-vous à votre compte ou contactez notre équipe pour devenir partenaire.",
      cta_whatsapp: "Discuter sur WhatsApp",
      cta_email_label: "Envoyer un e-mail",
      contact_form: {
        title: "Contacter My GlobalTopup",
        subtitle: "Envoyez-nous un message — notre équipe vous répondra dans les plus brefs délais.",
        field_name: "Nom complet",
        field_email: "Adresse e-mail",
        field_phone: "Téléphone mobile (facultatif)",
        field_subject: "Objet (facultatif)",
        field_message: "Message",
        hint_phone: "Format international, par ex. +56961234567",
        ph_name: "Ex. : Jean Dupont",
        ph_subject: "Comment pouvons-nous vous aider ?",
        ph_message: "Parlez-nous brièvement de votre activité et de la façon dont nous pouvons vous aider.",
        err_name: "Veuillez saisir votre nom complet.",
        err_email: "Saisissez une adresse e-mail valide.",
        err_phone: "Utilisez le format international (par ex. +56961234567).",
        err_message: "Rédigez un court message (au moins 5 caractères).",
        err_message_long: "Message trop long (2000 caractères maximum).",
        err_send: "Nous n'avons pas pu livrer votre message. Veuillez réessayer bientôt.",
        cancel: "Annuler",
        send: "Envoyer le message",
        sending: "Envoi…",
        close: "Fermer",
        done: "Terminé",
        success_title: "Message envoyé avec succès",
        success_body: "Merci d'avoir contacté My GlobalTopup. Notre équipe vous répondra dans les plus brefs délais.",
      },
      footer_tagline: "Une plateforme simple, rapide et sécurisée pour les recharges mondiales et les paiements numériques.",
      footer_company: "Société",
      footer_services: "Services",
      footer_products: "Produits",
      footer_legal: "Légal",
      footer_privacy: "Politique de confidentialité",
      footer_terms: "Conditions générales",
      footer_rights: "Tous droits réservés.",
      footer_login: "Connexion",
      footer_forgot: "Mot de passe oublié",
      footer_follow: "Suivez-nous",
      footer_download: "Téléchargez l'application",
      footer_play_get: "Disponible sur",
      legal_back_home: "Retour à l'accueil",
    },
    branding: {
      stats_section: "Landing page",
      stats_title: "Statistiques de la Landing Page",
      stats_hint: "Chiffres affichés sur la page d'accueil publique. Chaque statistique reste masquée tant que vous ne l'avez pas activée et renseignée avec une valeur confirmée (ex. « 400+ », « 70+ », « 24/7 »). Le bloc entier peut être désactivé avec le commutateur ci-dessous.",
      stats_section_on: "Section visible sur la page d'accueil",
      stats_section_off: "Section masquée — aucune statistique ne sera affichée",
      stats_label_ph: "Libellé (ex. Opérateurs)",
      stats_value_ph: "Valeur (ex. 400+, 24/7)",
      stats_shown: "Affichée",
      stats_hidden: "Masquée",
      stats_saved: "Statistiques de la landing page enregistrées",
    },
  },
};

export default fr;
